import { render, staticRenderFns } from "./UnloadingBaseClassEdit.vue?vue&type=template&id=b24da0b6&lang=pug"
import script from "./UnloadingBaseClassEdit.vue?vue&type=script&lang=js"
export * from "./UnloadingBaseClassEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports